var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useState, useEffect } from 'react';
import { Input } from 'reactstrap';
import { mapToCssModules } from '../../utils/className';
export const SmlsInputText = (_a) => {
    var { id, type = 'text', value, textLabel, defaultValue = '', className = '', disabled = false, errorMessage = 'Error message', forceError = false, icon, maxLength, placeholder, inputMode, pattern, regex = undefined, errorId = 'lbl_msgInvalid_1', ref, debouncedTime = 500, onChange = () => undefined, onFocus = () => undefined, onBlur = () => undefined, validate = () => true, onKeyPress = () => undefined } = _a, rest = __rest(_a, ["id", "type", "value", "textLabel", "defaultValue", "className", "disabled", "errorMessage", "forceError", "icon", "maxLength", "placeholder", "inputMode", "pattern", "regex", "errorId", "ref", "debouncedTime", "onChange", "onFocus", "onBlur", "validate", "onKeyPress"])
    // eslint-disable-next-line sonarjs/cognitive-complexity
    ;
    const [isFocused, setIsFocused] = useState(false);
    const [isValidInput, setIsValidInput] = useState(true);
    const [isTyping, setIsTyping] = useState(false);
    const [isFilled, setIsFilled] = useState(false);
    const [innerValue, setInnerValue] = useState('');
    const enableOutline = useCallback((e) => {
        setIsFocused(true);
        onFocus(e);
    }, []);
    const disableOutline = useCallback((e) => {
        setIsFocused(false);
        onBlur(e);
    }, []);
    const handleDebouncedValue = () => {
        const hasValue = innerValue.length > 0;
        setIsTyping(false);
        setIsFilled(hasValue);
        setIsValidInput(hasValue ? validate(innerValue) : true);
    };
    useEffect(() => {
        setIsValidInput(true);
        const debounceTimeout = setTimeout(handleDebouncedValue, debouncedTime);
        return () => {
            clearTimeout(debounceTimeout);
        };
    }, [innerValue]);
    useEffect(() => {
        return setInnerValue(() => {
            if (value)
                return value;
            return '';
        });
    }, [value]);
    const handleOnChange = useCallback((event) => {
        const text = event.target.value;
        setIsTyping(true);
        if (regex && Boolean(text.match(regex)))
            return;
        onChange(event);
        setInnerValue(text);
    }, [regex]);
    const generateId = () => {
        if (id)
            return id;
        return textLabel;
    };
    return (React.createElement("div", { className: mapToCssModules([
            'input-group',
            disabled ? 'disabled' : '',
            isTyping ? 'typing' : '',
            isFilled ? 'filled' : '',
            isFocused ? 'input-outline' : '',
            !isValidInput || forceError ? 'error' : '',
            icon ? 'icon' : '',
        ]) },
        textLabel && React.createElement("label", { htmlFor: generateId() }, textLabel),
        React.createElement("div", null,
            React.createElement(Input, Object.assign({ id: generateId(), type: type, inputMode: inputMode, defaultValue: defaultValue, className: className, disabled: disabled, value: innerValue, ref: ref, onChange: handleOnChange, onFocus: enableOutline, onBlur: disableOutline, placeholder: placeholder, maxLength: maxLength, pattern: pattern, onKeyPress: onKeyPress }, rest)),
            icon),
        React.createElement("div", { className: "input-error" }, (!isValidInput || forceError) && (React.createElement(React.Fragment, null,
            React.createElement("i", { className: "material-icons" }, "error_outline"),
            React.createElement("label", { id: errorId, htmlFor: "input-text" }, errorMessage))))));
};
//# sourceMappingURL=index.js.map